var map = {
	"./Bako.png": 209,
	"./Managero.png": 210,
	"./Vocalo.png": 211,
	"./facebook.png": 212,
	"./github.png": 213,
	"./header-background.jpg": 214,
	"./instagram.png": 215,
	"./linkedin.png": 216,
	"./logo.png": 20,
	"./overlay-bg.png": 217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;